import CommonService from '../services/CommonService';
import DashboardLite from '../services/DashboardLite';
import IndividualPortalService from '../services/IndividualPortalService';
import SsapService from '../services/SsapService';

export const COMMON_SVC = 'COMMON_SVC';
export const DASHBOARD_LITE_SVC = 'DASHBOARD_LITE_SVC';
export const INDIVIDUAL_PORTAL_SVC = 'INDIVIDUAL_PORTAL_SVC';
export const SSAP_SVC = 'SSAP_SVC';

const config = { };
const services = { };

export default (type, options = { }) => {

    const serviceConfig = {
        ...config,
        ...options
    };

    if(!services[type]) {
        switch (type) {
            case COMMON_SVC:
                services[ type ] = new CommonService(serviceConfig);
                break;

            case DASHBOARD_LITE_SVC:
                services[ type ] = new DashboardLite(serviceConfig);
                break;

            case INDIVIDUAL_PORTAL_SVC:
                services[ type ] = new IndividualPortalService(serviceConfig);
                break;

            case SSAP_SVC:
                services[ type ] = new SsapService(serviceConfig);
                break;
        }
    }

    return services[ type ];
};